import { render } from "./Clock.vue?vue&type=template&id=1888353b"
import script from "./Clock.vue?vue&type=script&lang=js"
export * from "./Clock.vue?vue&type=script&lang=js"

import exportComponent from "/Users/fee/Documents/JavaProjects/高校宿舍管理系统java/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__